<div
  fxLayout="column"
  fxLayoutAlign="center center"
  class="contact-page-container header-image-panel"
>
  <div
    class="panel-title"
  >
    <h2
      class="header-image-panel-title"
    >
      {{ 'pages.contact.title' | translate }}
    </h2>
  </div>
  <div
    class="panel-image-container"
    style="background-image: url('/assets/images/preview.jpg')"
  >
    <div
      class="hip-panel-container"
    >
      <address
        fxLayout="column"
        fxLayoutAlign="space-between start"
        class="header-image-panel-panel"
      >
        <h3>
          {{ 'pages.contact.data.title' | translate }}
        </h3>
        <div
          fxLayout="column"
          fxLayoutAlign="center start"
          class="contact-details"
        >
          <h2
            class="contact-details-title"
          >
            {{ 'pages.contact.data.address' | translate }}
          </h2>
          <a
            [href]="'tel:' + agencyService.agency.phone"
            target="_blank"
            class="contact-details-link"
            appGtagEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="phone_click"
            appFbqEvent="Lead"
            [customData]="{content_name: 'phone_click', content_category: 'click'}"
          >
            {{ agencyService.agency.phone | beautify }}
          </a>
          <a
            [href]="'https://maps.google.com?daddr='
            + agencyService.agency.latitude + ','
            + agencyService.agency.longitude + '&amp;ll='"
            target="_blank"
            class="contact-details-link"
            appGtagEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="maps_click"
            appFbqEvent="Lead"
            [customData]="{content_name: 'maps_click', content_category: 'click'}"
          >
            {{ agencyService.agency.address }}
          </a>
          <a
            [href]="'mailto:' + agencyService.agency.email"
            target="_blank"
            class="contact-details-link"
            appGtagEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="email_click"
            appFbqEvent="Lead"
            [customData]="{content_name: 'email_click', content_category: 'click'}"
          >
            {{ agencyService.agency.email }}
          </a>
        </div>
        <app-social-icons-base [isTooltipBelow]="true"></app-social-icons-base>
      </address>
    </div>
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-sm="space-between center"
    class="contact-page-bottom-section"
  >
    <app-contact-form [title]="'pages.contact.form_subtitle' | translate"></app-contact-form>
    <div
      class="google-map"
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="center center"
    >
      <app-google-map-iframe
        [latitude]="agencyService.agency.latitude"
        [longitude]="agencyService.agency.longitude"
      >
      </app-google-map-iframe>
      <a
        [href]="'https://maps.google.com?daddr='
        + agencyService.agency.latitude + ','
        + agencyService.agency.longitude + '&amp;ll='"
        class="mobile-map"
        fxHide.gt-xs
        target="_blank"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="maps_click"
        appFbqEvent="Lead"
        [customData]="{content_name: 'maps_click', content_category: 'click'}"
      >
        <div
          fxLayout="column"
          fxLayoutAlign="center center"
        >
          <img
            src="/assets/icons/contact/location.svg"
            alt=""
          >
          <label translate>
            Vezi localizarea pe hartă
          </label>
        </div>
      </a>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.html